
import type { InterchangeEventRow } from './types';
import Vue, { PropType } from 'vue';

export default Vue.extend({
	name: 'FallbackInterpreter',
	props: {
		row: {
			type: Object as PropType<InterchangeEventRow>,
			required: true
		}
	}
});
